{
  "commonHeader": {
    "upgradeToPro": "Yükselt",
    "learnMore": "Daha fazla bilgi edinin",
    "AIProductivitySuite": {
      "title": "Yapay Zeka Üretkenlik Paketi",
      "desc": "İlham veren tartışmaları etkileyici çıktılara dönüştürün."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Kuruluşunuzun hesabını yapay zeka ile yönetin",
        "description": "Hesap sorularınıza akıllı yanıtlar alın ve ayarlarda gezinme konusunda yardım alın.",
        "terms": "Zoom’un beta özelliklerini kullanarak {0} kabul etmiş olursunuz",
        "termsText": "Zoom Beta Programı Koşullarını"
      },
      "diveDeeper": "Daha fazla bilgi",
      "shareFeedback": "Geri bildiriminizi {0} içinde paylaşın",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Kuruluşunuzun hesabı hakkında sorun",
      "heroInvite": "Hesabıma nasıl yeni bir kullanıcı davet ederim?",
      "heroGroups": "Kullanıcıları gruplara nasıl atarım?",
      "heroRoles": "Rolleri ve izinleri nasıl yönetirim?"
    },
    "backMainAccount": "Ana hesaba dön",
    "discoverProducts": "Ürünleri keşfet",
    "pricing": "Fiyatlandırma",
    "more": "Diğer",
    "sidebarExpanded": "genişletildi",
    "sidebarCollapsed": "daraltıldı",
    "search": "Ara",
    "users": "Kullanıcılar",
    "settings": "Hesap ayarları",
    "navigation": "Gezinme",
    "clear": "Temizle",
    "searchPlaceholderAll": "Kullanıcı, hesap ayarı veya gezinme ara",
    "searchPlaceholderUsers": "Kullanıcı veya gezinme ara",
    "searchPlaceholderSettings": "Hesap ayarı veya gezinme ara",
    "searchPlaceholderNav": "Gezinmede ara",
    "searchGuide": "Aramaya başlamak için anahtar sözcükler yazın",
    "installOnDesktop": "Masaüstüne yükle",
    "downloadCenter": "İndirme merkezi",
    "getInTouch": "Bize ulaşın",
    "featuredProduct": "öne çıkan ürün",
    "logo": {
      "adminCenter": "Yönetim merkezi",
      "subAccount": "Alt hesap yönetiliyor",
      "externalAccount": "Yetkilendirilmiş hesap yönetiliyor"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Daha fazla bilgi edinin",
      "gotIt": "Anladım"
    },
    "coachMark": {
      "dvsTipsTitle": "Bölümler artık kullanılabilir",
      "dvsTipsContent": "Bölümler, hesabınızda belirli Zoom ürünlerinin birden fazla örneğini oluşturmak için kullanılır."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Daha fazla bilgi edinin",
      "gotIt": "Anladım"
    },
    "coachMark": {
      "extAccountTipsTitle": "Harici hesapları yönetin",
      "extAccountTipsContent": "Başka bir hesabı yönetmeniz mi gerekiyor? Sadece bir istek gönderin; onaylandıktan sonra erişim sizde!"
    }
  },
  "feedback": {
    "dialogTitle": "Geri bildirim gönderin",
    "itemLableForProductArea": "Ürün Türü",
    "itemLableForSatisfied": "Deneyiminizden ne kadar memnun kaldınız?",
    "dissatisfied": "Hiç memnun değil",
    "satisfied": "Çok Memnun",
    "itemLableForFeedback": "Geri Bildirim",
    "placeholder": "Fikirleriniz, yorumlarınız ve önerileriniz için teşekkür ederiz.",
    "btnCancel": "İptal",
    "btnSubmit": "Gönder",
    "supportTips": "Teknik destek için lütfen şu adresi ziyaret edin:",
    "btnSupport": "Destek.",
    "messages": {
      "success": "Geri bildiriminiz için teşekkürler!",
      "productFailed": "Ürün Alanı gereklidir.",
      "scoreFailed": "Memnuniyet puanı gereklidir."
    },
    "products": {
      "General": "Genel",
      "AI": "YZ",
      "Apps": "Uygulamalar",
      "Calendar": "Takvim",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Posta",
      "Meetings": "Toplantılar",
      "Notes": "Notlar",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Zamanlayıcı",
      "Tasks": "Görevler",
      "TeamChat": "Ekip sohbeti",
      "WebinarsAndEvents": "Web seminerleri ve etkinlikler",
      "Whiteboard": "Beyaz tahta",
      "WorkflowAutomations": "İş akışı otomasyonları",
      "WorkspaceReservation": "Çalışma alanı rezervasyonu",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Bu sorumluluk reddi beyanı, hesap yöneticiniz tarafından oluşturulmuştur.",
    "cancel": "İptal",
    "agree": "Kabul Et"
  },
  "shared": {
    "sideMenu": {
      "personal": "Kişisel",
      "admin": "Yönetici",
      "menu": "Menü",
      "pinned": "Sabitlendi",
      "pin": "Sabitle",
      "unpin": "Sabitlemeyi kaldır",
      "moveItem": "Öğeyi taşı",
      "myAccount": "Hesabım",
      "upgradeToPro": "Pro’ya yükselt",
      "grabbedKeyboard": "{0} tutuldu. Taşımak için yukarı ve aşağı okları, bırakmak için boşluk veya Enter kullanın.",
      "dropped": "{0} bırakıldı.",
      "releasedUnchanged": "{0} bırakıldı, konum değişmedi.",
      "movedToPosition": "{0}, {2} öğeden {1}. konuma taşındı.",
      "movedUp": "{0} yukarı taşındı, konum {1}/{2}.",
      "movedDown": "{0} aşağı taşındı, konum {1}/{2}.",
      "movedUpNew": "{0} yukarı taşındı, yeni konum {1}/{2}",
      "movedDownNew": "{0} aşağı taşındı, yeni konum {1}/{2}",
      "cannotMoveFurther": "{0} daha fazla taşınamaz.",
      "grabbedMouse": "{0} tutuldu. Konumu değiştirmek için fareyi hareket ettirin, bırakmak için tıklayın, iptal etmek için Escape’e basın."
    },
    "item": "Öğe",
    "gotIt": "Anladım",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Telefon numarası başarıyla eklendi! Artık bunu gelecekteki giriş yapma ve hesap kurtarma işlemleri için kullanabilirsiniz.",
    "mfa_to_signin_phone_success": "{phone}, artık {email} için kullanılacak giriş yapma numarasıdır.",
    "login_passkey_bound_success": "Geçiş anahtarı başarıyla oluşturuldu"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Aşağıdaki gelişmiş yönetim özellikleri yalnızca lisanslı kullanıcılar ve iş birliği kullanıcıları için geçerlidir",
      "licensed_basic": "Aşağıdaki gelişmiş yönetim özellikleri yalnızca lisanslı ve temel kullanıcılar için geçerlidir",
      "licensed": "Aşağıdaki gelişmiş yönetim özellikleri yalnızca lisanslı kullanıcılar için geçerlidir"
    },
    "support": "- Hesap ayarlarında ve kullanıcı grubu ayarlarında desteklenir",
    "archive_product": {
      "title": "Toplantıları ve web seminerlerini arşivle",
      "detail": "- Hesabınızdaki kullanıcılar katıldığında toplantılar arşivlenir. Bu ayarı kullanmak için Zoom App Marketplace üzerinden bir <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">arşivleme uygulaması</a> yükleyin."
    },
    "restrict": {
      "title": "Kullanıcıların toplantıya katıldıklarında seçili özellikleri kullanmalarını kısıtla",
      "detail": "- Toplantı sahipleri, seçili özellikleri toplantılar için etkinleştirse bile bunlar kullanılamaz."
    },
    "meeting_integration": {
      "title": "Toplantı içi sohbet DLP (Veri Kaybını Önleme) entegrasyonunu etkinleştir",
      "detail": "- Etkinleştirildiğinde DLP (Veri Kaybını Önleme), bir katılımcının gönderdiği hem herkese açık hem de özel sohbet mesajlarına uygulanır. Bir toplantıdaki katılımcılar (dahili/harici) sohbet ediyorsa ve herhangi bir mesaj oturum sahibi organizasyonun uyumluluk politikalarına aykırıysa mesajlar derhal silinir."
    },
    "chat_tool": {
      "title": "Sohbet kuralları aracı",
      "detail": "- Paylaşılan içerikte tanımlı anahtar kelimeleri ve metin kalıplarını belirleyin ve kullanıcıların istenmeyen mesajlar paylaşmalarını engelleyin"
    },
    "information_barriers": {
      "title": "Bilgi engelleri",
      "detail": "- Bilgi engelleri, uyumluluk amacıyla belirli kullanıcılar arasındaki iletişimi denetler. İki gruptaki kullanıcılar arasına ve belirli kullanıcılara toplantı ve sohbet kısıtlamaları getirilebilir ve bu kullanıcıların belirli özellikleri (ör. toplantı içi sohbet, ekran paylaşımı ve dosya aktarımı) kullanmaları engellenebilir. Bu kısıtlamalar, gizli bilgilerin yetkisiz kullanıcılar arasında paylaşılmasını engeller."
    },
    "dashboard": {
      "title": "Pano",
      "detail": "- Toplantılar > geçmiş toplantılar panosunda, bazı kullanıcılar için yalnızca 3 aya ait veriler görüntülenebilir"
    },
    "reports": {
      "title": "Raporlar",
      "detail": "- Bazı kullanıcı raporlarında, bazı kullanıcılar için yalnızca 3 aylık veriler gösterilir: yasal uyarı raporu, rolsüz katılımcı günlüğü raporu, yönetici etkinlik günlükleri raporu ve giriş/çıkış raporu"
    },
    "close": "Kapat"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "{planName} planınız, {cancelDate} tarihinde iptal edilecektir. Belirtilen tarihten önce, web semineri lisanslarınızı yeniden etkinleştirebilirsiniz. {supportStartDate} - {supportEndDate} tarihleri arasında, mevcut web seminerlerinin verilerini almak için Müşteri Destek birimiyle iletişime geçebilirsiniz. {dataLossDate} itibarıyla, tüm web semineri verilerinizi kaybedeceksiniz.",
            "nonAdmin": "{planName} planınız, {cancelDate} tarihinde iptal edilecektir. Belirtilen tarihe kadar, web semineri lisanslarınızı yeniden etkinleştirmek için hesap yöneticinizle iletişime geçebilirsiniz. {supportStartDate} - {supportEndDate} tarihleri arasında, mevcut web seminerlerinin verilerini almak için Müşteri Destek birimiyle iletişime geçebilirsiniz. {dataLossDate} itibarıyla, hesabınızdaki tüm web seminerlerinin verilerini kaybedeceksiniz."
          },
          "admin": "{planName} planınız, {cancelDate} tarihinde iptal edilecektir. Belirtilen tarihe kadar web semineri lisanslarınızı yeniden etkinleştirebilirsiniz. {supportStartDate} - {supportEndDate} tarihleri arasında, mevcut web seminerleri için {supportContent} edinmek üzere müşteri destek birimiyle iletişime geçebilirsiniz. {dataLossDate} itibarıyla, hesabınızdaki tüm web seminerlerinin verilerini kaybedeceksiniz.",
          "nonAdmin": "{planName} planınız, {cancelDate} tarihinde iptal edilecektir. Belirtilen tarihe kadar, web semineri lisanslarınızı yeniden etkinleştirmek için hesap yöneticinizle iletişime geçebilirsiniz. {supportStartDate} - {supportEndDate} tarihleri arasında, mevcut web seminerleri için {supportContent} edinmek üzere müşteri destek birimiyle iletişime geçebilirsiniz. {dataLossDate} itibarıyla, hesabınızdaki tüm web seminerlerinin verilerini kaybedeceksiniz."
        },
        "expired": {
          "admin": "{planName} planınız iptal edildi. {supportStartDate} - {supportEndDate} arasında, mevcut web seminerleri için {supportContent} edinmek için müşteri desteği ile iletişime geçebilir veya veri erişimini yeniden sağlamak için Zoom Webinars'ı tekrar satın alabilirsiniz. {dataLossDate} itibarıyla, hesabınızdaki tüm web seminerlerinin verilerini kaybedeceksiniz.",
          "nonAdmin": "{planName} planınız iptal edildi. {supportStartDate} - {supportEndDate} arasında, mevcut web seminerleri için {supportContent} edinmek için müşteri desteği ile iletişime geçebilir veya veri erişimini yeniden sağlamak için Zoom Webinars'ı tekrar satın almasını sağlamak üzere yöneticinize başvurabilirsiniz. {dataLossDate} itibarıyla, hesabınızdaki tüm web seminerlerinin verilerini kaybedeceksiniz."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "{planName} planınız {pausedDate} tarihinde {pauseDuration} süreyle duraklatılacaktır. Duraklatma döneminde yalnızca mevcut web seminerlerini ve bunlara ait varlıkları görüntüleyebilirsiniz. Dilediğiniz zaman duraklatmayı sonlandırarak web semineri lisanslarınızın aboneliğini kullanmayı sürdürebilirsiniz.",
            "nonAdmin": "{planName} planınız {pausedDate} tarihinde {pauseDuration} süreyle duraklatılacaktır. Duraklatma döneminde yalnızca mevcut web seminerlerini ve bunlara ait varlıkları görüntüleyebilirsiniz. Dilediğiniz zaman, duraklatmayı kaldırmak ve web semineri lisanslarınızın aboneliğini kullanmayı sürdürmek için hesap yöneticinizle iletişime geçebilirsiniz."
          },
          "admin": "{planName} planınız {pausedDate} tarihinde {pauseDuration} süreyle duraklatılacaktır. Duraklatma döneminde yalnızca {supportContent} görüntülenebilir. Dilediğiniz zaman duraklatmayı sonlandırarak web semineri lisanslarınızın aboneliğini kullanmayı sürdürebilirsiniz.",
          "nonAdmin": "{planName} planınız {pausedDate} tarihinde {pauseDuration} süreyle duraklatılacaktır. Duraklatma döneminde yalnızca {supportContent} görüntülenebilir. Dilediğiniz zaman, duraklatmayı kaldırmak ve web semineri lisanslarınızın aboneliğini kullanmayı sürdürmek için hesap yöneticinizle iletişime geçebilirsiniz."
        },
        "active": {
          "webinars": {
            "admin": "{planName} planınız {pausedDate} itibarıyla geçerli olacak şekilde {pauseDuration} süreyle duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerleri görüntülenebilir. Dilediğiniz zaman, web semineri lisanslarınızın aboneliğini kullanmayı sürdürebilirsiniz.",
            "nonAdmin": "{planName} planınız {pausedDate} itibarıyla geçerli olacak şekilde {pauseDuration} süreyle duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerleri görüntülenebilir. Dilediğiniz zaman hesap yöneticinizle iletişime geçerek web semineri lisanslarınızın aboneliğinin sürdürülmesini isteyebilirsiniz."
          },
          "admin": "{planName} planınız {pauseDuration} süreyle duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerleri için {supportContent} görüntülenebilir. Dilediğiniz zaman, web semineri lisanslarınızın aboneliğini kullanmayı sürdürebilirsiniz.",
          "nonAdmin": "{planName} planınız {pauseDuration} süreyle duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerleri için {supportContent} görüntülenebilir. Dilediğiniz zaman hesap yöneticinizle iletişime geçerek web semineri lisanslarınızın aboneliğinin sürdürülmesini isteyebilirsiniz."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "{planName} lisansınız {pausedDate} tarihinde {pauseDuration} boyunca duraklatılacaktır. Web seminerleri düzenlemeye devam etmek için duraklatma işlemi geçerlilik kazanmadan önce bu kullanıcıya aktif bir lisans atayın. Bu lisansı kullanmaya devam etmek için duraklatmayı da kaldırabilirsiniz.",
            "nonAdmin": "{planName} lisansınız {pausedDate} tarihinde {pauseDuration} boyunca duraklatılacaktır. Duraklatma döneminde yalnızca mevcut web seminerlerini ve bunlara ait varlıkları görüntüleyebilirsiniz. Web seminerleri düzenlemeye devam etmek isterseniz duraklatma işlemi geçerlilik kazanmadan önce hesabınıza aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin."
          },
          "active": {
            "admin": "{planName} lisansınız {pausedDate} tarihinden itibaren {pauseDuration} boyunca duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerlerini görüntüleyebilirsiniz. Web seminerleri düzenlemeye devam etmek için dilediğiniz zaman lisansınızın aboneliğini yeniden başlatabilir veya hesabınıza aktif bir lisans atayabilirsiniz.",
            "nonAdmin": "{planName} lisansınız {pausedDate} tarihinden itibaren {pauseDuration} boyunca duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerlerini görüntüleyebilirsiniz. Duraklatma sırasında web seminerleri düzenlemek isterseniz hesabınıza aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin."
          }
        },
        "cancel": {
          "active": {
            "admin": "{planName} lisansınız {cancelDate} tarihinde iptal edilecektir. Web semineri düzenlemeye devam etmek için iptal yürürlüğe girmeden önce web semineri lisansınızı yeniden etkinleştirin veya etkin bir lisans atayın. Herhangi bir işlem yapılmazsa mevcut web semineri verilerinizi almak üzere Müşteri Destek birimiyle iletişime geçmek için {supportStartDate} - {supportEndDate} arasında bir ek süreniz olacaktır. {dataLossDate} tarihinden sonra hesabınızla ilişkili tüm web semineri verileri kalıcı olarak silinecektir.",
            "nonAdmin": "{planName} lisansınız {cancelDate} tarihinde iptal edilecektir. Web semineri düzenlemeye devam etmek için iptal yürürlüğe girmeden önce web semineri lisansınızı yeniden etkinleştirmek veya etkin bir lisans atamak üzere hesap yöneticinizle iletişime geçin. Herhangi bir işlem yapılmazsa mevcut web semineri verilerinizi almak üzere Müşteri Destek birimiyle iletişime geçmek için {supportStartDate} - {supportEndDate} arasında bir ek süreniz olacaktır. {dataLossDate} tarihinden sonra hesabınızla ilişkili tüm web semineri verileri kalıcı olarak silinecektir."
          },
          "expired": {
            "admin": "{planName} lisansınız iptal edildi. Web seminerleri düzenlemeye devam etmek için bu kullanıcıya aktif bir lisans atayın. Mevcut web semineri verilerini almak için {supportStartDate} - {supportEndDate} tarihleri arasında Müşteri Desteği ile iletişime geçebilirsiniz.",
            "nonAdmin": "{planName} lisansınız iptal edildi. Web seminerleri düzenlemeye devam etmek isterseniz profilinize aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin. Mevcut web semineri verilerini almak için {supportStartDate} - {supportEndDate} tarihleri arasında Müşteri Desteği ile iletişime geçin."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "{planName} lisansınız {pausedDate} tarihinde {pauseDuration} boyunca duraklatılacaktır. Duraklatma döneminde yalnızca önceki web seminerlerine ait {supportContent} içeriklerini görüntüleyebilirsiniz. Web seminerlerinin varlıklarına erişmeye devam etmek için duraklatma işlemi geçerlilik kazanmadan önce bu kullanıcıya aktif bir lisans atayın. Bu lisansı kullanmaya devam etmek için duraklatmayı da kaldırabilirsiniz.",
              "nonAdmin": "{planName} lisansınız {pausedDate} tarihinde {pauseDuration} boyunca duraklatılacaktır. Duraklatma döneminde yalnızca {supportContent} içeriklerini görüntüleyebilirsiniz. Web seminerlerinin varlıklarına erişmeye devam etmek isterseniz profilinize aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin."
            },
            "active": {
              "admin": "{planName} planınız {pausedDate} tarihinden itibaren {pauseDuration} boyunca duraklatılmıştır. Duraklatma sırasında yalnızca mevcut web seminerlerine ait {supportContent} içeriklerini görüntüleyebilirsiniz. Web seminerlerinin varlıklarına erişmeye devam etmek için lütfen hesabınıza aktif bir lisans atayın. Ayrıca dilediğiniz zaman bu lisansın aboneliğini yeniden başlatabilirsiniz.",
              "nonAdmin": "{planName} planınız {pausedDate} tarihinden itibaren {pauseDuration} boyunca duraklatılmıştır. Duraklatma sırasında yalnızca web seminerlerine ait {supportContent} içeriklerini görüntüleyebilirsiniz. Duraklatma sırasında web seminerleri düzenlemek isterseniz hesabınıza aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin."
            }
          },
          "cancel": {
            "active": {
              "admin": "{planName} planınız {cancelDate} tarihinde iptal edilecek. Web seminerleri düzenlemeye devam etmek için lütfen iptal işlemi geçerlilik kazanmadan önce hesabınıza aktif bir lisans atayın. Bu lisansı {cancelDate} tarihinden önce yeniden etkinleştirebilirsiniz. Mevcut web seminerleri için {supportContent} içeriğini almak üzere {supportStartDate} - {supportEndDate} tarihleri arasında Müşteri Desteği ile iletişime geçebilirsiniz.",
              "nonAdmin": "{planName} lisansınız {cancelDate} tarihinde iptal edilecektir. Web semineri düzenlemeye devam etmek için iptal yürürlüğe girmeden önce web semineri lisansınızı yeniden etkinleştirmek veya etkin bir lisans atamak üzere hesap yöneticinizle iletişime geçin. Herhangi bir işlem yapılmazsa {supportStartDate} - {supportEndDate} arasında Müşteri Destek birimiyle iletişime geçerek mevcut web seminerlerinizin {supportContent} öğesini almak için bir ek süreniz olacaktır. {dataLossDate} tarihinden sonra hesabınızla ilişkili tüm web semineri verileri kalıcı olarak silinecektir."
            },
            "expired": {
              "admin": "{planName} lisansınız iptal edildi. Web seminerleri düzenlemeye devam etmek için bu kullanıcıya aktif bir lisans atayın. Mevcut web seminerlerinin {supportContent} içeriklerini almak için {supportStartDate} ile {supportEndDate} tarihleri arasında Müşteri Desteği ile iletişime geçin.",
              "nonAdmin": "{planName} lisansınız iptal edildi. Web seminerleri düzenlemeye devam etmek isterseniz profilinize aktif bir lisans ataması için lütfen hesap yöneticinizle iletişime geçin. Mevcut web seminerlerinin {supportContent} içeriklerini almak için {supportStartDate} - {supportEndDate} tarihleri arasında Müşteri Desteği ile iletişime geçin."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "veri",
        "recordingsAndTranscripts": "kayıtlar ve dökümler",
        "reports": "rapor",
        "summaries": "özetler",
        "dashboard": "pano"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "önceki web seminerlerinin Kayıtları ve Dökümleri",
          "reports": "önceki web semineri raporları",
          "summaries": "önceki web seminerlerinin özetleri",
          "dashboard": "önceki web seminerlerinin panoları",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Planı yeniden etkinleştir",
    "purchasePlan": "Plan satın al",
    "removePause": "Duraklatmayı iptal et",
    "resumeSubscription": "Aboneliği sürdür",
    "month": "ay",
    "months": "ay",
    "assignLicense": "Lisans Ata"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Anladım"
    },
    "coachMark": {
      "tipsTitle": "Adres Defteri, Müşteri Dizini olacak",
      "tipsContent": "Ekim 2026 sürümünde amacını daha iyi yansıtmak için Adres Defteri’nin adını Müşteri Dizini olarak değiştiriyoruz. Mevcut tüm işlevler, izinler ve iş akışları aynı kalacaktır; müşteri listelerini (adres defterleri) ve kişileri bugün yaptığınız gibi yönetmeye devam edeceksiniz."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Hüküm ve şartlarımızı güncelliyoruz",
    "agreeSub": "Zoom'u kullanmaya devam ettiğinizde, <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Hizmet Şartlarını</a> ve <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Gizlilik Politikasını</a> kabul etmiş sayılırsınız.",
    "continue": "Devam"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Ana hesaba dön",
      "backLinkedAccount": "Bağlı hesaba dön",
      "backMyAccount": "Hesabım’a dön",
      "myAccount": "Hesabım"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion artık hesabınız için kullanılabilir",
      "desc": "Hesabınızda kullanabileceğiniz bazı Custom AI Companion özellikleri şunlardır:",
      "studioTitle": "AI Studio",
      "studioDesc": "Kuruluşunuz için AI Companion deneyimini özelleştirin.",
      "integrationsTitle": "Üçüncü taraf entegrasyonları",
      "integrationsDesc": "İş akışlarınızı kolaylaştırmak için üçüncü taraf uygulamalardan yararlanın.",
      "clipsTitle": "Zoom Clips için özel avatarlar",
      "clipsDesc": "Kullanıcıların kliplerinde kullanmak üzere yapay zeka avatarlarını kişiselleştirmesine izin verin."
    },
    "coachMark": {
      "licenseTitle": "Atamanız gereken {0} Custom AI Companion lisansınız var",
      "licenseDesc": "Kullanıcılarınızın gelişmiş AI Companion özelliklerini kullanmaya başlaması için bu lisansları <b>Kullanıcı Yönetimi</b> altında atayın.",
      "settingTitle": "Hesabınız için Custom AI Companion ayarlarına göz atın",
      "settingDesc": "Her Custom AI özelliğinin ayarlarını <b>Hesap Ayarları</b> altında yapılandırın. <a href=\"/account/setting?tab=aicompanion\">Ayarlara git</a>",
      "groupSettingTitle": "Grubunuz için Custom AI ayarlarına göz atın",
      "groupSettingDesc": "Her Custom AI özelliğinin ayarlarını <b>Grup Ayarları</b> altında yapılandırın. <a href=\"/account/group\">Ayarlara git</a>"
    },
    "common": {
      "learnMore": "Daha fazla bilgi edinin",
      "quickTour": "Hızlı bir tur atın",
      "remindLater": "Daha sonra hatırlat",
      "dismiss": "Kapat",
      "next": "İleri",
      "back": "Geri",
      "gotIt": "Anladım",
      "goToSetting": "Ayara git"
    },
    "aiPanelToast": "Tüm Custom AI Companion özelliklerini kullanmaya başlamak için <b>Zoom Workplace’te yapay zeka paneli</b> ayarını açın."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Anladım",
      "next": "İleri",
      "remindMeLater": "Daha sonra hatırlat",
      "waffleMenuTitle": "Yeni Zoom web deneyimine hoş geldiniz",
      "waffleMenuDesc": "Zoom ürünlerine her yerden yeni <b>ürün menümüzle.</b> erişin.",
      "profileMenuTitle": "Hesabım",
      "profileMenuDesc": "Profilinizi ve kişisel ayarlarınızı <b>Hesabım.</b> bölümünde bulun.",
      "personalTitle": "İhtiyacınız olan her şeye erişin",
      "personalDesc": "<b>Hesabım</b> profilinizi, ayarlarınızı, toplantı dökümlerinizi ve daha fazlasını içerir.",
      "adminCenterTitle": "Kuruluş ayarlarını Yönetici Merkezi’nde bulun",
      "adminCenterDesc": "Yeni <b>Yönetici Merkezi</b>, ürünleri yapılandırmanıza ve tüm kuruluşunuz için ayarları düzenlemenize olanak tanır.",
      "adminMenuForTitle": "Yönetici Merkezi’ni bir profesyonel gibi kullanın",
      "adminMenuForAccountSettings": "<b>Ayarlar</b>, kuruluşunuzdaki herkes için varsayılan ürün ayarlarına erişmenizi sağlar.",
      "adminMenuForContentManagementItem": "<b>İçerik yönetimi</b>, kullanıcıların oluşturduğu tüm içerikleri yönetebileceğiniz yerdir.",
      "adminMenuForConfigureProductsItem": "<b>Ürün yapılandırması</b>, ürünlerinizi kurmanıza ve yönetici görevlerini tamamlamanıza olanak tanır.",
      "adminMenuForNoItems": "Yeni yönetici merkezi, hesap ayarlarınıza ve ürünlerinize daha kolay erişmenizi ve bunları yönetmenizi sağlar. Daha hızlı erişim için istediğiniz öğeleri sabitleyebilirsiniz.",
      "tryNewExperience": "Yeni deneyimi dene",
      "tryNewExperienceDetail": "Deneyin! İstediğiniz zaman bu klasik deneyime geri dönebilirsiniz.",
      "tryNewExperienceTitle": "Zoom Web için yeni görünüm!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Tüm hakları saklıdır.",
    "terms": "Koşullar",
    "privacy": "Gizlilik",
    "trust_center": "Güven Merkezi",
    "acceptable_use_guidelines": "Kabul Edilebilir Kullanım Yönergeleri",
    "legal": "Yasal",
    "do_not_sell_my_personal_information": "Gizlilik Tercihleriniz",
    "cookie_preferences": "Çerez Tercihleri",
    "pricing": "Planlar ve Fiyatlandırma",
    "feedback": "Geri Bildirim",
    "contact_us": "Bize Ulaşın"
  },
  "termChange": {
    "changeTerm": {
      "title": "Yenileme Süresi Değişiklik Sözleşmesi",
      "quoteNumbers": "Değiştirilmiş Sipariş Formu/Formları - {0}",
      "content1": "Bu koşulları kabul ederek Müşteri, Zoom Communications, Inc. (“Zoom”) ile Müşteri arasındaki tüm Sipariş Formları için mevcut abonelik yenileme süresini, taahhüt edilen süreyi aydan aya yenileme süresinden {0} olacak şekilde değiştirerek tadil etmeyi kabul eder. Bu taahhüt karşılığında Zoom, Müşteri’nin mevcut fiyatlandırmasını ilk yeni yenileme süresinin tamamı boyunca korumayı kabul eder.",
      "content2": "Müşteri, {0} olan yeni yenileme süresinin Müşteri aşağıda “Kabul ediyorum” düğmesine tıkladığında geçerli olduğunu ve yeni yenileme süresinin Müşteri’nin mevcut aydan aya yenileme süresinin sona ermesini izleyen günde başlayacağını anlar. Bu yeni yenileme süresi, Zoom ile halihazırda yürürlükte olan tüm Sipariş Formları için geçerlidir ve bu Sipariş Formları kapsamındaki tüm gelecekteki yenileme süreleri aynı uzunlukta olacaktır.",
      "content3": "Müşteri, yapılan tek değişikliğin yenileme süresi olduğunu ve Zoom ile halihazırda yürürlükte olan her Sipariş Formunun diğer tüm hüküm ve koşullarının değişmeden, kendi koşullarına uygun olarak tam yürürlükte ve geçerli kalacağını kabul eder.",
      "content4": "Ayrıca bunun Müşteri ile Zoom arasında sözleşmesel bir taahhüt olduğunu kabul edersiniz.",
      "agreementText": "“Kabul ediyorum” düğmesine tıklayarak, bu değişikliği Müşteri adına yapmaya yetkili olduğunuzu ve Müşteri’nin yukarıda ayrıntılı olarak belirtilen hüküm ve koşulları kabul ettiğini onaylarsınız.",
      "IDecline": "Reddediyorum",
      "IAccept": "Kabul ediyorum"
    },
    "unableToChangeTerm": {
      "title": "Yenileme süresi değiştirilemiyor",
      "content": "Hesabınız yenileme süresini güncelleme hakkına sahip değil. Bunun bir hata olduğunu düşünüyorsanız <a target=\"_blank\" href=\"{0}\">bize ulaşın</a>.",
      "acceptedTitle": "Yenileme Süresi Uzatıldı",
      "acceptedContent": "Yenileme koşullarını daha önce kabul ettiniz. Başka bir işlem gerekmez.",
      "GotIt": "Anladım"
    },
    "termLengthUpdated": "Yenileme süresi uzunluğu {0} ay olarak güncellendi.",
    "termLengthUnchanged": "Süre uzunluğu değişmedi.",
    "errorInfo": "Bir sunucu hatası oluştu. Tekrar deneyin.",
    "x12MonthTerm": "on iki (12) aylık süre",
    "x24MonthTerm": "yirmi dört (24) aylık süre",
    "x12MonthTermPlural": "on iki (12) ay",
    "x24MonthTermPlural": "yirmi dört (24) ay"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Hesabınızın {0} tarihinde <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">yeni Zoom web deneyimine</a> güncellenmesi planlanıyor.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Ne zaman güncelleneceğini inceleyin</a>"
    },
    "completed": {
      "content": "Yeni Zoom web deneyimi artık hesabınızdaki tüm kullanıcılar için etkin. Kullanıcılar bir sonraki oturum açışlarında güncellenmiş arayüzü görecek."
    }
  }
}
